'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { toast } from '@/components/ui/use-toast';
import { authPoliciesKeyPrefix, createInitialPolicyForm, useCreateAuthenticationPolicy } from '@/features/authentication-policy';
import { handleApiError } from '@/lib/api/error';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { PolicyStepperScreen } from '../-components/PolicyStepperScreen';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/policies/new/')({
  component: NewAuthPolicyPage
});
const BASE_LINK = '/settings/authentication/policies/new';
function NewAuthPolicyPage() {
  const {
    i18n,
    t
  } = useTranslation(defaultNS, {
    keyPrefix: authPoliciesKeyPrefix
  });
  const navigate = useNavigate();
  const createMutation = useCreateAuthenticationPolicy();
  const [errorMessage, setErrorMessage] = useState('');
  return <PolicyStepperScreen baseLink={BASE_LINK} initialValue={createInitialPolicyForm} isDefault={false} isSubmitting={createMutation.isPending} errorMessage={errorMessage} onSubmit={body => {
    setErrorMessage('');
    createMutation.mutate(body, {
      // 作ったポリシーの評価フローをそのまま確認できるよう詳細へ送る
      onSuccess: created => {
        toast({
          description: t($ => $.toast.created)
        });
        void navigate({
          to: '/settings/authentication/policies/$id',
          params: {
            id: created.id
          }
        });
      },
      onError: error => {
        setErrorMessage(handleApiError(error, {
          language: i18n.language
        }).message);
      }
    });
  }} />;
}